module.exports = __webpack_public_path__ + "career-icon-fsa.1TuKhejS.svg";